export function formatDate(value, options, locale) {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isFinite(date.getTime())
    ? date.toLocaleDateString(locale || 'en-IN', { ...options, timeZone: 'Asia/Kolkata' })
    : '—';
}

export function formatDateTime(value, missing = '—') {
  if (!value) return missing;
  const date = new Date(value);
  return Number.isFinite(date.getTime())
    ? date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
    : '—';
}
